import CONFIG from '../../globalVariables.js';

class PubliciteService {
  /**
   * Récupérer une publicité par ville et catégorie (par ID)
   * @param {string} villeId - ID de la ville
   * @param {string} categorieId - ID de la catégorie
   * @returns {Promise<Object>} - Publicité
   */
  static async getPubliciteVilleById(villeId, categorieId) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/annonces/ville/${villeId}/${categorieId}`);
      
      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.error || 'Erreur lors de la récupération');
      }
      
      return data.data;
      
    } catch (error) {
      console.error('Erreur PubliciteService.getPubliciteVilleById:', error);
      throw error;
    }
  }

  /**
   * Récupérer une publicité par nom de ville et catégorie
   * @param {string} villeName - Nom de la ville
   * @param {string} categorieName - Nom de la catégorie
   * @returns {Promise<Object>} - Publicité
   */
  static async getPubliciteVille(villeName, categorieName) {
    try {
      const url = `${CONFIG.PATH_API}/annonces/by-name/ville/${encodeURIComponent(villeName)}/${encodeURIComponent(categorieName)}`;
      console.log('🌐 PubliciteService - URL complète:', url);
      console.log('🌐 PubliciteService - CONFIG.PATH_API:', CONFIG.PATH_API);
      console.log('🌐 PubliciteService - villeName:', villeName);
      console.log('🌐 PubliciteService - categorieName:', categorieName);
      
      console.log('🚀 PubliciteService - Début de fetch...');
      const response = await fetch(url);
      console.log('📡 PubliciteService - Response status:', response.status);
      console.log('📡 PubliciteService - Response ok:', response.ok);
      console.log('📡 PubliciteService - Response headers:', response.headers);
      console.log('📡 PubliciteService - Response type:', response.type);
      console.log('📡 PubliciteService - Response url:', response.url);
      
      if (!response.ok) {
        console.error('❌ Response not ok:', response.status, response.statusText);
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
      
      console.log('🔄 PubliciteService - Parsing JSON...');
      const data = await response.json();
      console.log('✅ PubliciteService - Data received:', data);
      
      if (!data.success) {
        throw new Error(data.error || 'Erreur lors de la récupération');
      }
      
      return data.data;
      
    } catch (error) {
      console.error('🚨 PubliciteService.getPubliciteVille - Erreur:', error);
      console.error('🚨 PubliciteService.getPubliciteVille - Error name:', error.name);
      console.error('🚨 PubliciteService.getPubliciteVille - Error message:', error.message);
      console.error('🚨 PubliciteService.getPubliciteVille - Error stack:', error.stack);
      throw error;
    }
  }

  /**
   * Récupérer une publicité par département et catégorie (par ID)
   * @param {string} departementId - ID du département
   * @param {string} categorieId - ID de la catégorie
   * @returns {Promise<Object>} - Publicité
   */
  static async getPubliciteDepartementById(departementId, categorieId) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/annonces/departement/${departementId}/${categorieId}`);
      
      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.error || 'Erreur lors de la récupération');
      }
      
      return data.data;
      
    } catch (error) {
      console.error('❌ Erreur PubliciteService.getPubliciteDepartementById:', error);
      throw error;
    }
  }

  /**
   * Récupérer une publicité par nom de département et catégorie
   * @param {string} departementName - Nom du département
   * @param {string} categorieName - Nom de la catégorie
   * @returns {Promise<Object>} - Publicité
   */
  static async getPubliciteDepartement(departementName, categorieName) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/annonces/by-name/departement/${encodeURIComponent(departementName)}/${encodeURIComponent(categorieName)}`);
      
      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.error || 'Erreur lors de la récupération');
      }
      
      return data.data;
      
    } catch (error) {
      console.error('❌ Erreur PubliciteService.getPubliciteDepartement:', error);
      throw error;
    }
  }

  /**
   * Récupérer toutes les publicités
   * @returns {Promise<Array>} - Liste des publicités
   */
  static async getAllPublicites() {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/annonces`);
      
      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.error || 'Erreur lors de la récupération');
      }
      
      return data.data;
      
    } catch (error) {
      console.error('Erreur PubliciteService.getAllPublicites:', error);
      throw error;
    }
  }

  /**
   * Récupérer une publicité par ID
   * @param {string} id - ID de la publicité
   * @returns {Promise<Object>} - Publicité
   */
  static async getPubliciteById(id) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/annonces/${id}`);
      
      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.error || 'Erreur lors de la récupération');
      }
      
      return data.data;
      
    } catch (error) {
      console.error('Erreur PubliciteService.getPubliciteById:', error);
      throw error;
    }
  }

  /**
   * Créer une nouvelle publicité
   * @param {Object} publiciteData - Données de la publicité
   * @returns {Promise<Object>} - Publicité créée
   */
  static async createPublicite(publiciteData) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/annonces`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(publiciteData),
      });
      
      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.error || 'Erreur lors de la création');
      }
      
      return data.data;
      
    } catch (error) {
      console.error('Erreur PubliciteService.createPublicite:', error);
      throw error;
    }
  }

  /**
   * Modifier une publicité
   * @param {string} id - ID de la publicité
   * @param {Object} publiciteData - Nouvelles données de la publicité
   * @returns {Promise<Object>} - Publicité modifiée
   */
  static async updatePublicite(id, publiciteData) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/annonces/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(publiciteData),
      });
      
      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.error || 'Erreur lors de la modification');
      }
      
      return data.data;
      
    } catch (error) {
      console.error('Erreur PubliciteService.updatePublicite:', error);
      throw error;
    }
  }

  /**
   * Supprimer une publicité
   * @param {string} id - ID de la publicité
   * @returns {Promise<boolean>} - Succès de la suppression
   */
  static async deletePublicite(id) {
    try {
      const response = await fetch(`${CONFIG.PATH_API}/annonces/${id}`, {
        method: 'DELETE',
      });
      
      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.error || 'Erreur lors de la suppression');
      }
      
      return true;
      
    } catch (error) {
      console.error('Erreur PubliciteService.deletePublicite:', error);
      throw error;
    }
  }
}

export default PubliciteService; 